/**
 * FacetMenuTempo Component
 */

import { getDefaultTempoFilter, getDefaultTempoValues } from '../../../../redux/selectors/staticData';

import * as classNames from 'classnames';
import { isEqual, mapValues, NumericDictionary } from 'lodash';
import { Range } from 'rc-slider';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';

import { IQueryStringContext, QueryStringContext } from '../../../../contexts/queryString';
import { getTempoFilter } from '../../../../contexts/queryString/selectors';
import Button from '../../../atoms/buttons/Button';

interface IOwnStateProps {
  defaultValues: GQL.IIntegerRangeFilter;
  initialValues: GQL.IIntegerRangeFilter;
  tempoNames: NumericDictionary<string | null>;
}

interface IQueryStringContextProps extends Pick<IQueryStringContext, 'addTempoFilter' | 'removeTempoFilter'> {
  tempoFilter: GQL.IIntegerRangeFilter | undefined;
}

interface IOwnProps {
  className?: string;
}

type FacetMenuTempoProps =
  & IOwnProps
  & IOwnStateProps
  & IQueryStringContextProps;

interface IOwnState {
  values: GQL.IIntegerRangeFilter;
}

const classes = new BEM('facet-menu');

class FacetMenuTempo extends React.Component<FacetMenuTempoProps, IOwnState> {
  constructor(props: FacetMenuTempoProps) {
    super(props);

    this.state = {
      values: props.initialValues,
    };
  }

  onRangeAfterChange = ([minimum, maximum]: [number, number]) => {
    this.setState({ values: { minimum, maximum } });
  }

  onReset = () => {
    this.setState({ values: this.props.initialValues }, () => {
      this.props.removeTempoFilter();
    });
  }

  onSubmit = () => {
    this.props.addTempoFilter({
      minimum: this.state.values.minimum! + 1,
      maximum: this.state.values.maximum! + 1,
    });
  }

  render() {
    const {
      className,
      defaultValues,
      initialValues,
      tempoNames,
    } = this.props;

    const extraClasses = classNames(
      className,
    );

    return (
      <div {...classes('', 'tempo', extraClasses) }>
        <Range
          min={defaultValues.minimum}
          max={defaultValues.maximum}
          defaultValue={[this.state.values.minimum, this.state.values.maximum]}
          allowCross={false}
          marks={tempoNames}
          onAfterChange={this.onRangeAfterChange}
          dots
          vertical
        />
        <div>
          <Button
            label="Set"
            variant="pill"
            size="small-medium"
            colorScheme="dark"
            onClick={this.onSubmit}
            disabled={isEqual(initialValues, this.state.values)}
          />
          <Button
            label="Reset"
            variant="hyperlink"
            size="medium"
            onClick={this.onReset}
            disabled={isEqual(initialValues, defaultValues)}
          />
        </div>
      </div>
    );
  }
}

const ConnectedFacetMenuTempo = connect<IOwnStateProps, {}, IOwnProps & IQueryStringContextProps, IStoreState>(
  (state, ownProps) => ({
    defaultValues: getDefaultTempoValues(state),
    initialValues: getDefaultTempoFilter(state, ownProps),
    tempoNames: mapValues(state.staticData.tempos, 'name'),
  }),
)(FacetMenuTempo);

const FacetMenuTempoWithQueryStringContext: React.SFC<IOwnProps> = (props) => (
  <QueryStringContext.Consumer>
    {(ctx) => (
      <ConnectedFacetMenuTempo
        addTempoFilter={ctx.addTempoFilter}
        removeTempoFilter={ctx.removeTempoFilter}
        tempoFilter={getTempoFilter(ctx)}
        {...props}
      />
    )}
  </QueryStringContext.Consumer>
);

export default FacetMenuTempoWithQueryStringContext;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/organisms/search/FacetMenu/FacetMenuTempo.tsx